import { isBefore } from "date-fns";

import { createSelector, createSlice } from "@reduxjs/toolkit";

import { CandidateNote } from "apis/candidateNote";

import { Action, State } from "./store";

const sortByUpdatedBy = (A: CandidateNote, B: CandidateNote) =>
  isBefore(new Date(A.updatedAt), new Date(B.updatedAt)) ? 1 : -1;

export const CandidateNotesSlice = createSlice({
  name: "candidateNotes",
  initialState: {
    value: undefined as CandidateNote[] | undefined,
  },
  reducers: {
    addCandidateNotes: (state, action: Action<CandidateNote[]>) => {
      // override only non drafts, draft should remain unless there is a refresh
      state.value = [
        ...action.payload,
        ...(state.value || []).filter((note) => note.isDraft),
      ].sort(sortByUpdatedBy);
    },
    addCandidateNote: (state, action: Action<CandidateNote>) => {
      state.value = [action.payload, ...(state.value || [])].sort(
        sortByUpdatedBy
      );
    },
    updateCandidateNote: (state, action: Action<CandidateNote>) => {
      state.value = state.value
        ?.map((note) => (note.id === action.payload.id ? action.payload : note))
        .sort(sortByUpdatedBy);
    },
    deleteCandidateNote: (state, action: Action<string>) => {
      state.value = state.value?.filter((note) => note.id != action.payload);
    },
  },
});

export const {
  addCandidateNotes,
  addCandidateNote,
  updateCandidateNote,
  deleteCandidateNote,
} = CandidateNotesSlice.actions;

export const selectCandidateNotes = (
  state: State
): CandidateNote[] | undefined => {
  return state.candidateNotes.value;
};

export const selectTranscriptCandidateNotes = createSelector(
  [selectCandidateNotes],
  (candidateNotes) => {
    return candidateNotes?.filter((note) => note.type === "transcript");
  }
);

export default CandidateNotesSlice.reducer;
